export { viewPromptCreators } from './view-prompts'
export { chartPrompts } from './chart-prompts'
export const prompts = Object.freeze({})
